import { Logger } from 'AppShell/appshell_types/loggerTypes';
import { useLogger } from 'AppShell/logger/LoggerProvider';
import { errorToJson } from 'Utils/errors/errorToJson';
import { useMemo } from 'react';

const useRemoteLogger = (remoteName: string) => {
    const logger = useLogger();

    const remoteLogger: Logger = useMemo(() => {
        const newLogger = {
            ...logger,
            log: (type, entry, customData) => {
                const microFrontendIndex = { application: remoteName };

                const customDataWithRemoteEntry = {
                    ...microFrontendIndex,
                    ...(customData instanceof Error ? errorToJson(customData) : {}),
                    ...customData,
                } as Object;

                return logger.log(type, entry, customDataWithRemoteEntry);
            },
        };
        Object.setPrototypeOf(newLogger, Object.getPrototypeOf(logger));

        return newLogger;
    }, [logger, remoteName]);

    return remoteLogger;
};

export default useRemoteLogger;
